import { useMutation, useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { loginService, getInfoService,checkPasswordResetTokenService,resetPasswordService, forgotPasswordService} from "./Auth.service";
import { store_setAuthData } from "./Auth.store";

export const useAuthMutation = () => {
  return useMutation((req) => loginService(req), {
    retry: false,
  });
};

export const useGetInfoQuery = () => {
  const dispatch = useDispatch();
  return useQuery("auth", getInfoService, {
    enabled: false,
    onSuccess: (data) => {
      dispatch(store_setAuthData(data));
      const cachedStore = JSON.parse(localStorage.getItem("thriving/store") || "{}");
      localStorage.setItem("thriving/store", JSON.stringify({
        ...cachedStore,
        ...data
      }));
    },
  });
};
// Forgot password
export const useForgotPasswordMutation = () => {
  return useMutation(
    (request) => forgotPasswordService(request),
    {
      retry: false,
    }
  );
};
// Reset password
export const useResetPasswordMutation = () => {
  return useMutation(
    (request) => resetPasswordService(request),
    {
      retry: false,
    }
  );
};
